 
 
 
 
 
 
define(['http', './utils', 'security', 'endpoints', './batchSearch'],
    function(http, utils, security, endpoints, batchSearch) {
        'use strict';

        var queryParamNames = [
            'limit', 'ofs', 'streetNumber', 'streetName', 'crossStreet', 'municipality', 'municipalitySubdivision',
            'countryTertiarySubdivision', 'countrySecondarySubdivision', 'countrySubdivision', 'postalCode', 'language',
            'countryCode'
        ];

        return {
            structuredGeocode: function(options, callback) {
                var pathParams = {}, queryParams = {};

                // Required: "countryCode" param
                queryParams.countryCode = utils.required(options.countryCode,
                    '"countryCode" parameter is required for structuredGeocode service.');

                // if an API key is specified, include it
                // an API key can be omitted if an API proxy is being used
                queryParams.key = utils.or(options.key, security.getKey('services/search'));

                utils.extractQueryParams(options, queryParams, queryParamNames);

                http.get({
                    url: '{protocol}://' + endpoints.structuredGeocode,
                    pathParameters: pathParams,
                    queryParameters: queryParams,
                    callback: callback,
                    callbackParam: 'callback',
                    fail: options.fail
                });
            },
            batch: batchSearch(queryParamNames, { queryRequired: false, type: 'structuredGeocode'})
        };
    }
);



// WEBPACK FOOTER //
// ./rest/structuredGeocode.js